export default __webpack_public_path__ + "static/media/keller-old-devices.13d88fd8.png";